import apiClient from "../../../utils/apiClient";

/**
 * The office's door to a student's documents: `upload(item, { onProgress })`,
 * `remove(docId)`, `verify(docId, { status, note })`, `list()`. The student's
 * own doors (signed in, or the emailed link) are `profileApi.js`.
 * Multipart names the Content-Type so axios leaves the boundary to the browser.
 */
const form = ({ kind, companyId, label, file }) => {
  const body = new FormData();
  body.append("kind", kind);
  if (companyId) body.append("companyId", companyId);
  if (label) body.append("label", label);
  body.append("file", file, file.name);
  return body;
};

/**
 * The upload itself, with progress. Held at 99 until the server answers: the
 * bytes are sent, the row is not saved yet.
 */
const post = (url, item, { onProgress } = {}) => apiClient.post(url, form(item), {
  headers: { "Content-Type": "multipart/form-data" },
  onUploadProgress: (e) => {
    if (onProgress && e.total) onProgress(Math.min(99, Math.round((e.loaded / e.total) * 100)));
  },
}).then((r) => r.data.document);

/** The office, on a student's record. */
export const staffDocumentsApi = (studentId) => ({
  list: () => apiClient.get(`/student-profile/students/${studentId}`).then((r) => r.data),
  upload: (item, opts) => post(`/student-profile/students/${studentId}/documents`, item, opts),
  remove: (docId) => apiClient.delete(`/student-profile/students/${studentId}/documents/${docId}`),
  verify: (docId, body) => apiClient.post(`/student-profile/students/${studentId}/documents/${docId}/verify`, body).then((r) => r.data.document),
});

/** The sentence for a request that failed. */
export const uploadProblem = (err, fallback = "The document could not be uploaded.") => {
  if (!err?.response) return "The connection dropped before the upload finished. Nothing was saved — try again.";
  return err.response.data?.message || fallback;
};
